import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'business-list.list-view.bulk-delete-modal.software-title-issue-term-refresh',
		defaultMessage: 'Delete {count, plural, one {# issue} other {# issues}}?',
		description: 'Title of the confirmation modal asking if user really wants to delete issues',
	},
	deteleButton: {
		id: 'bulk-delete-trigger.delete-button',
		defaultMessage: 'Delete',
		description:
			'Text on delete button in the bulk operations floating toolbar to delete multiple issues',
	},

	maxIssuesExceededWarning: {
		id: 'issue-navigator.bulk-operations-wrapper.bulk-delete.max-issues-exceeded-warning',
		defaultMessage:
			'You can only bulk delete up to {maxIssueLimit, plural, one {# issue} other {# issues}} at once.',
		description:
			'Warning popup that is displayed when the user selects more than the max number of issues and clicks the delete button on the floating toolbar.',
	},
});
